import { createTheme, MantineColorsTuple } from "@mantine/core";

const primary: MantineColorsTuple = [
  "#ffe9ec",
  "#ffd1d6",
  "#f9a2ab",
  "#f4707d",
  "#ef4757",
  "#e94560",
  "#e83346",
  "#ce2538",
  "#b81b31",
  "#a00c28",
];

export const theme = createTheme({
  primaryColor: "primary",
  colors: { primary },
  other: {
    bg: "#1a1a2e",
    card: "#16213e",
    accent: "#0f3460",
    text: "#eeeeee",
    muted: "#888888",
    success: "#4caf50",
    warning: "#ff9800",
    danger: "#f44336",
  },
  components: {
    Paper: {
      defaultProps: {
        bg: "#16213e",
        c: "#eeeeee",
      },
    },
    Card: {
      defaultProps: {
        bg: "#16213e",
        c: "#eeeeee",
      },
    },
  },
});
